import Grid from "@material-ui/core/Grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import PlanDetailsComponent from "./plan.details.component";
import PlanListComponent from "./plan.list.component";




function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  
export default function Plan() {
    const history = useHistory();
    const query = useQuery();
  
    return (
        <div>
           {query.get("mode") === "create" ? (
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginBottom: "20px",
              height: "2em",
              color: "inherit",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
           
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Plan Management- Create Plan
              </span>
            
          </Grid>
          ) : null}
    
          {(() => {
            switch (query.get("mode")) {
              case "viewList":
                return <PlanListComponent />;
              case "create":
                return <PlanDetailsComponent />;
              default:
                history.push("/plans?mode=viewList");
            }
          })()}
        </div>
      );
}